import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
    olddata:{}
   
    
}
const mutations={
   
    
    getCategoryData(state,value){
        
        
     
        post(urls.admin.category.index,value).then((result)=>{
          console.log(result)  
          state.result=result
          state.olddata=result
         
          
          
       
        
       
           
        });
        
    },


    addCategoryData(state,value){
        
      
     
        post(urls.admin.category.add,value).then((result)=>{
            
          
            state.result=result
         
         
          
          
       
        
       
           
        });
        
    },
    editCategoryData(state,value){
        
      
     
        post(urls.admin.category.edit,value).then((result)=>{
          
          state.result=result
        
        });
        
    },
    delCategoryData(state,value){
        
      
     
        post(urls.admin.category.delete,value).then((result)=>{
          
          state.result=result
        
        });
        
    },
    


}
const  actions={
    getCategoryDataAction(context,value){
       
        context.commit("getCategoryData",value)
       
    },
    addCategoryDataAction(context,value){
       
        context.commit("addCategoryData",value)
       
    },
    editCategoryDataAction(context,value){
       
        context.commit("editCategoryData",value)
       
    },
    delCategoryDataAction(context,value){
       
        context.commit("delCategoryData",value)
       
    },

    
    
   

}

export default {state,mutations,actions}